var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v(_vm._s(_vm.customization.title || _vm.widget.title || _vm.$t('customize_this_title')))]),_c('hr',{staticClass:"w-100"})])}
var staticRenderFns = []

export { render, staticRenderFns }